<template>
		<div class="home-page">
		<Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
      <div class="mission-content ac crfff">
        <div class="fs50 mt50">{{$t('longHairEffects')}}</div>
        <div class="css-1asaykn mt50">
          <div class="css-1asaykn mt20">
            <img width="100%" src="../../static/images/longHairEffects.gif" />
          </div>
          <div class="css-12nj5ib mt30">
            <div style="">{{$t('longHairEffects_tip')}}</div>
          </div>
          <div id="controlBox" class="oneImageInput mt50">
            <div class="oneImageInput-content">
              <input type="file" @change="convertToBase64" class="file" accept="image/*" mutiple="mutiple">
              <div class="imageInputBox">
                <div class="uploadBox uploadIcon">
                  <img style="width:80%;" v-if="imageBase64" :src="imageBase64" />
                  <div class="" v-else>
                    <img width="40" src="../../static/images/transparent.png">
                    <div class="label"> {{$t('Upload')}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ac mt30">
          <button style="width: calc(100% - 100px);" @click="uploadImage" class="button"><strong>{{$t('Generate')}}</strong></button>
      </div>
      <div class="flex mt50" style="justify-content: space-around;width: 94%;margin: 0 auto;">
        <button class="btn btn-blue">{{$t('ChancesLeft')}} : {{score}}</button>
<!--        <button class="button fs12 ml10" @click="goPurchaseChances"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 0.1rem;" width="15" src="../../static/images/buy.png"></button>-->
      </div>
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
              <div class="image ac" v-if="imageShow">
                <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{$t('downTips1')}}</div>
               <img v-if="isShowResult==1" :src="detail.url" style="width:80%;" />
               <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;" />

               <div class="tab mt50">
                  <span @click="getResult(1)" :class="{'active':isShowResult==1}">{{$t('Result')}}</span>
                  <span @click="getResult(2)" :class="{'active':isShowResult==2}">{{$t('Original')}}</span>
               </div>
                <div class="img-tools">
                  <div class="ac disflex mt30">
                   <div class="input-item">
                     <div class="input-item2" v-if="isShowResult==1">
                       <input class="input" disabled v-model="detail.url"  type="" placeholder="">
                       <img id="copycode" :data-clipboard-text="detail.url" @click="copy" v-if="detail.url" style="margin-left: 10px;width: 1rem" src="../../static/images/Copy.png" />
                     </div>
                     <div class="input-item2" v-if="isShowResult==2">
                       <input class="input" disabled v-model="detail.original_url"  type="" placeholder="">
                       <img id="copycode" :data-clipboard-text="detail.original_url" @click="copy" v-if="detail.original_url" style="margin-left: 10px;width: 1rem" src="../../static/images/Copy.png" />
                     </div>
                   </div>
                  </div>
                </div>
              </div>
          </div>
      </Dialog>


      <Dialog ref="processDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
        <div class="alert-modal ac" slot="mdBox" >
          <div class="fs33 mt50 ac">{{processMsg}}</div>
          <button class="button mt30" @click="closeProcessDialog">{{$t('OK')}}</button>
        </div>
      </Dialog>

		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
			detail:{},
			isShow:false,
			value:50,
			imageShow:false,
			imageBase64: null,
			imageTpye:'',
			withScratch:false,
			isImgModel:false,
			isImage:true,
      score:0,
      isShowResult:1,
      processMsg:"",
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
      getResult(type){
        this.isShowResult = type
      },
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
      back(){
        this.$router.go(-1);
      },
		getHome(){
			let that =this;
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
        });
			})
		},
    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
         // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    uploadImage() {
      let that = this
      if(!that.imageBase64){
        that.$utils.alertText(that.$t('uploadTips'),100);
        return;
      }
      let data ={
        image:{
          type:that.imageTpye,
          content:that.imageBase64
        },
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/long_hair_effects',data,r =>{
        that.$parent.loadModal(false);
        that.getHome()
        if(r.code==0){
          that.$refs.processDialog.showMaskFun();
          that.processMsg = r.msg
          return;
        }
      	that.$parent.returnCode(r,function(){
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
      	});
      })
    },
    getImage(){
       const link = document.createElement('a')
       link.style.display = 'none'
       link.href = this.detail.url
       console.log(link.href)
       // link.target = '_blank'
       link.setAttribute('download', '文件名称')
       document.body.appendChild(link)
       link.click()
        window.open(this.detail.url, '_blank')

    },
    closeTmgDialog(){
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    closeProcessDialog(){
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
    goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/longHairEffects.vue